module.exports = __webpack_public_path__ + "img/pool-icon-classic.3d7646e6.svg";